/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/goals/goalBase.controller.ts" />

module Meevo.Plugins.EmployeeGoal {
    'use strict';

    import NounEnum = Meevo.Model.NounEnum;
    import VerbEnum = Meevo.Model.VerbEnum;
    import GoalBaseController = Meevo.Components.Goals.GoalBaseController;
    import IGoalRowModel = Meevo.Components.Goals.IGoalRowModel;
    import IGoalRowLine = Meevo.Components.Goals.IGoalRowLine;
    import IGoalColumn = Meevo.Components.Goals.IGoalColumn;
    import IGoalBaseCriteria = Meevo.Components.Goals.IGoalBaseCriteria;
    import GoalCategoryEnum = Meevo.Components.Goals.GoalCategoryEnum;
    import GoalViewEnum = Meevo.Components.Goals.GoalViewEnum;
    import GoalInputTypeEnum = Meevo.Components.Goals.GoalInputTypeEnum;
    import IPagerModel = Meevo.Plugins.MarketPricing.IPagerModel;
    import IPagerConfig = angular.ui.bootstrap.IPagerConfig;
    import IShortCutsService = Meevo.Components.ShortCuts.IShortCutsService;

    class EmployeeGoalController extends GoalBaseController {
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            '$q',
            '$timeout',
            '$translate',
            '$locale',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            'meevo.components.common.IdentityService',
            'meevo.components.short-cuts.ShortCutsService'
        ];
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        public editSecurityKey = this.securityKeys.GOALS_EMPLOYEEGOALS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
        public departmentRowList: any;
        public departmentRowListBackup: any;
        public departmentBackupList: any;
        public someEmployeeId: any;
        public showFilters: boolean = false;
        public isStartApplyFilter: boolean;
        public originalEmployeesGoalsList: any;


        private departmentsLoaded: ng.IPromise<any>;

        public preventDoubleWarning: boolean = false;
        public goalsSlider: boolean = false;

        public filterCriteria: IGoalBaseCriteria = {
            criteria: {
                goalCategories: [],
                year: this.currentYear,
                employeeIds: [],
                departmentId: '',
                view: GoalViewEnum.Default
            }
        };
        public employeeCriteria = {
            includeActive: true,
            showEmployeesOnly: true,
            departmentId: this.filterCriteria.criteria.departmentId
        };
        public pagerList: IPagerModel;

        get isEditing() {
            return !this.showEdit;
        }

        get isRequestAllowed(): boolean {
            let criteria = this.filterCriteria.criteria;

            return !!criteria.year
                && (<any[]>criteria.goalCategories).length
                && (criteria.departmentId || criteria.employeeIds.length);
        }

        set isRequestAllowed(value) {}

        public defaultEmployeeId: Guid = this.identityService.current().userAuthId;
        protected viewAllEmployeesDeny: boolean = false;
        protected viewAllEmployeesHide: boolean;
        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IStateService,
            protected $q: angular.IQService,
            protected $timeout: angular.ITimeoutService,
            protected $translate: angular.translate.ITranslateService,
            protected $locale: angular.ILocaleService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected shortCutsService: IShortCutsService

        ) {
            super($scope,$rootScope,$state,$q,$timeout,$translate,$locale,appSettings,dataService,modalService,busyService,securityService,trackingService,identityService, shortCutsService);
            this.securityService.checkSecurityKey(this.securityKeys.GOALS_EMPLOYEEGOALS_ACTION_VIEWALLEMPLOYEEGOALS)
                .then((securityCode: Meevo.Model.SecurityAccessEnum) => {
                    this.viewAllEmployeesHide = securityCode === Meevo.Model.SecurityAccessEnum.Hide;
                    this.viewAllEmployeesDeny = securityCode === Meevo.Model.SecurityAccessEnum.Deny;
                    this.defaultEmployeeId = this.viewAllEmployeesHide ? this.identityService.current().userAuthId : null;
                    this.filterCriteria.criteria.employeeIds = this.defaultEmployeeId ? [this.defaultEmployeeId] : [];
                });
            this.$rootScope.$on(Meevo.Components.Common.Messages.CHECK_SECURITY_KEY_AFTER_ELEVATION, (requestedSecurityKeys, displayName) => {
                if(displayName[0] === "GOALS_EMPLOYEEGOALS_ACTION_VIEWALLEMPLOYEEGOALS") {
                    this.viewAllEmployeesDeny = false;
                    this.changeCategory();
                }
            });
        }

        init() {
            // Department list
            this.departmentsLoaded = this.dataService.customMethodData(`${this.appSettings.API_ROOT}/department/List`, 'POST', null).then((res: any) => {
                _.each(res.data, (department: any) => {
                    this.departmentList.push(department);
                });
                this.departmentBackupList = angular.copy(this.departmentList);
            });
            // Employee name
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/employee/${this.identityService.current().userAuthId}`, 'GET', null).then((res: any) => {

                const employeeName = ((res.data && res.data.displayName) || '').replace(/,/g, '').trim();

                if (employeeName) {
                    this.defaultEmployeeId = this.identityService.current().userAuthId;
                    this.employee = res.data;
                    this.filterCriteria.criteria.employeeIds = [this.defaultEmployeeId];

                    this.changeEmployee();
                } else {
                    this.busyService.stop();
                }
            }, (data: any) => {
                this.busyService.stop();
            });
        }

        /**
         * Cancel button
         * */
        cancel(): void {
            super.cancel();

            this.updatePagerGoals();
        }

        public backToFilters = () => {
            this.showFilters = true;
        }
        public sliderAnimation() {
            this.goalsSlider = !this.goalsSlider;
        }
        public getCategory(goalCategory) {
            switch (goalCategory) {
                case GoalCategoryEnum.AverageServiceTicket: { return 'LABEL_AVERAGE_TICKET' }
                case GoalCategoryEnum.FrequencyOfVisit: { return 'LABEL_FREQUENCY_OF_VISIT' }
                case GoalCategoryEnum.NewClientsPerMonth: { return 'LABEL_NEW_CLIENTS_PER_MONTH' }
                case GoalCategoryEnum.Rebook: { return 'LABEL_REBOOK' }
                case GoalCategoryEnum.Retail: { return 'LABEL_RETAIL' }
                case GoalCategoryEnum.NewClientRetention: { return 'LABEL_RETENTION' }
                case GoalCategoryEnum.Service: { return 'LABEL_SERVICE' }
                case GoalCategoryEnum.Rating: { return 'LABEL_5_STAR_RATING' }
                case GoalCategoryEnum.RequestRate: { return 'LABEL_REQUEST' }
                case GoalCategoryEnum.Membership: { return 'LABEL_MEMBERSHIP' }
                case GoalCategoryEnum.Productivity: { return 'LABEL_PRODUCTIVITY' }
                case GoalCategoryEnum.GiftCard: { return 'LABEL_GIFT_CARD_SALES' }
                default: { return null }
            }
        }

        /**
         * Change Measurement button
         * */
        changeMeasurement(): void {
            super.changeMeasurement();
            this.departmentRowList = this.formatGoals(angular.copy(this.departmentRowListBackup));

            this.updatePagerGoals();
        }

        updatePagerGoals() {
            let currentPage = this.pagerList.pages[this.pagerList.currentPage];

            _.each(currentPage, (el: any) => {
                el.goals = this.goalRowList[el.id];
            });

            this.connectFloatingHeaders();
        }

        edit(): void {
            super.edit();

            this.originalEmployeesGoalsList = angular.copy(this.pagerList);
        }

        /**
         * Saves the item currently being edited.
         */
        save(): angular.IPromise<any> {
            let goalCriteria = {
                    employeeGoals: []
                },
                goals = [],
                goalSaveRequest,
                inputType = this.getInputType();

            _.forEach(this.goalRowList, (employee: IGoalRowModel) => {
                if (!employee) return;

                _.forEach(employee.rows, (year: IGoalRowLine) => {
                    if (!year) return;

                    _.forEach(year.columns, (item: IGoalColumn) => {
                        if (!item) return;
                        item.departmentId = this.filterCriteria.criteria.departmentId;

                        let goal = this.backupGoalList.find((elem) => {
                            if (((item.employeeId == 0 && !elem.id) || elem.id == item.employeeId) &&
                                elem.month == item.month &&
                                elem.year == item.year &&
                                elem.goalCategory == item.goalCategory) {
                                return elem;
                            }
                        });

                        if (inputType === GoalInputTypeEnum.Numeric) {
                            if (item.goalCategory === GoalCategoryEnum.FrequencyOfVisit) {
                                if (item.value != goal.amount) {
                                    item.amount = item.value ? item.value : 0;
                                    item.actualAmount = item.actualValue;

                                    goals.push(item);
                                }
                            } else {
                                if (item.value != goal.unit) {
                                    item.unit = item.value;
                                    item.actualUnit = item.actualValue;

                                    goals.push(item);
                                }
                            }
                        } else if (inputType === GoalInputTypeEnum.Currency && (item.value != goal.amount)) {
                            item.amount = item.value;
                            item.actualAmount = item.actualValue;
                            goals.push(item);
                        } else if (inputType === GoalInputTypeEnum.Percentage && (item.value != goal.percent)) {
                            item.percent = item.value;
                            item.actualPercent = item.actualValue;
                            goals.push(item);
                        } else if (inputType === GoalInputTypeEnum.Float && (item.value != goal.amount)) {
                            item.amount = item.value;
                            item.actualAmount = item.actualValue;
                            goals.push(item);
                        }

                    });
                });
            });

            if (goals.length == 0) {
                goalSaveRequest = this.$q.defer();
                goalSaveRequest.reject(null);
                goalSaveRequest = goalSaveRequest.promise;
            } else {
                goalCriteria.employeeGoals = goals;
                goalSaveRequest = this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Goal/Employee`, 'PUT', goalCriteria).then((res: any) => {
                    this.changeCriteriaFilter();
                });
            }

            this.showEdit = true;
            this.isReadonly = true;

            return goalSaveRequest;
        }

        /**
         * Request for goals list
         */
        changeCriteriaFilter() {
            this.busyService.start();
            this.goalRowList = {};

            let departmentFilterCriteria = {
                criteria: {
                    goalCategories: this.filterCriteria.criteria.goalCategories,
                    year: this.filterCriteria.criteria.year,
                    departmentId: this.filterCriteria.criteria.departmentId,
                    view: this.filterCriteria.criteria.view
                }
            };
            if (this.goalCategory === GoalCategoryEnum.Rating) {
                departmentFilterCriteria.criteria['isHidden'] = null;
                departmentFilterCriteria.criteria['isDeleted'] = false;
            }

            if (this.filterCriteria.criteria.departmentId) {
                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/goal/Employee/Department`, 'POST', departmentFilterCriteria).then((res: any) => {
                    _.forEach(res.data.departmentOverall, (el: any, i) => {
                        el.id = el.departmentId;

                        if (res.data.differences.length > 0) {
                            let item;
                            for (let j = 0; j < res.data.differences.length; j++) {
                                if (j === i) {
                                    item = res.data.differences[j];
                                }
                            }

                            if (item.amount) {
                                el.goalDiff = item.amount;
                            }
                        }
                    });

                    this.departmentRowList = this.formatGoals(res.data.departmentOverall);
                    this.departmentRowListBackup = angular.copy(res.data.departmentOverall);
                });
            }
            this.pagerApplyFilter();
        };

        // Pager
        // Virtual method to interact with paging functionality
        public pagerDefaultCriteria() {
            return {
                includeActive: true,
                showEmployeesOnly: true,
                departmentId: this.filterCriteria.criteria.departmentId
            }
        }

        public forcePageLoading(criteria: any, itemsPerPage?: number): void {
        }

        public pagerApplyFilter() {
            this.preventDoubleWarning = true;
            let criteria = this.pagerDefaultCriteria();
            let itemsPerPage = this.employee ? 1000 : 5;
            this.showFilters = false;

            this.$timeout(() => this.forcePageLoading(criteria, itemsPerPage), 50);
        }

        public pagerOnApplyFilter(): boolean {
            this.showFilters = false;
            return this.isStartApplyFilter = true;
        }

        public pagerOnPageLoaded(isNewPage: boolean) {
            let currentPage = this.pagerList.pages[this.pagerList.currentPage];

            if (!currentPage) return;

            this.busyService.start();
            this.employeesList.length = 0;
            this.employeeIdsList.length = 0;

            _.each(currentPage, (employee: any) => {
                this.employeesList.push(employee);
                this.employeeIdsList.push(employee.id);
            });

            this.filterCriteria.criteria.employeeIds = this.employee && this.employee.id != null ? [this.employee.id] : this.employeeIdsList;

            if (this.employeeIdsList.length > 0) {
                this.loadEmployeeGoals();
            } else {
                this.busyService.stop();
                if (this.preventDoubleWarning) {
                    this.modalService.warning('MESSAGE_GOALS_EMPLOYEE_EMPTY');
                    this.preventDoubleWarning = false;
                }
            }

        }

        public asyncPager(): ng.IPromise<any> {
            let returnPromise: ng.IPromise<any>;

            let defer = this.$q.defer();
            this.viewAllEmployeesDeny ? defer.resolve(false) : defer.resolve(true);

            returnPromise = defer.promise;

            if (this.isStartApplyFilter) {
                this.isStartApplyFilter = false;
            } else if (!this.isReadonly) {
                returnPromise = this.checkSectionChangeData().then((resp) => {
                    if (resp) {
                        // Set default changes, extend for save link to original object

                        if (this.originalEmployeesGoalsList) {
                            _.extend(this.pagerList.pages, this.originalEmployeesGoalsList.pages);
                            this.originalEmployeesGoalsList = angular.copy(this.pagerList);
                            this.save();
                        }

                        return true;
                    }
                });
            }

            return returnPromise;
        }

        checkSectionChangeData(): ng.IPromise<any> {
            let returnPromise: ng.IPromise<any>;

            // check section has changes
            if (this.isSectionChangedData()) {
                returnPromise = this.modalService.confirm('MESSAGE_CLOSE_UNSAVED', Meevo.Components.Modal.ModalTranslationModes.Translate);
            } else {
                let defer = this.$q.defer();
                defer.resolve(true);
                returnPromise = defer.promise;
            }

            return returnPromise;
        }

        isSectionChangedData(): boolean {
            let answer = false,
                pagerListString = angular.toJson(this.pagerList.pages),
                originalListString = angular.toJson(this.originalEmployeesGoalsList.pages);

            if (this.originalEmployeesGoalsList) {
                answer = pagerListString !== originalListString;
            }
            return answer;
        }

        loadEmployeeGoals(): ng.IPromise<any> {
            let filterCriteria = angular.copy(this.filterCriteria);;
            if (this.goalCategory === GoalCategoryEnum.Rating) {
                filterCriteria.criteria['isHidden'] = null;
                filterCriteria.criteria['isDeleted'] = false;
            }

            return this.dataService.customMethodData(`${this.appSettings.API_ROOT}/goal/employee/List`, 'POST', filterCriteria).then((res: any) => {
                _.forEach(res.data, (el: any) => {
                    el.id = el.employeeId;
                    this.someEmployeeId = el.id;
                });
                this.showFilters = false;
                this.busyService.stop();

                this.backupGoalList = angular.copy(res.data);
                this.goalRowList = this.formatGoals(res.data);
                this.updatePagerGoals();
            });
        }

        changeItemColumn(itemRow) {
            if (this.isCountTotal) {
                this.countTotal(itemRow);
            }
        }

        changeTotalCallback(itemRow) {
            this.countTotalPerDay(itemRow);
        }

        changeDepartments(): void {
            this.filterCriteria.criteria.departmentId = this.departmentId;
            this.employeeCriteria.departmentId = this.departmentId;

            if (this.goalCategory) {
                this.changeCategory();
            }
        }

        changeCategory(): void {
            if ((this.departmentId || this.employee) && this.goalCategory) {
                super.changeCategory();
            }
        }

        changeEmployee(): void {
            if (this.employee) {
                this.$q.all({
                    departments: this.$q.when(this.departmentsLoaded),
                    employee: this.dataService.customMethodData(`${this.appSettings.API_ROOT}/employee/${this.employee.id}`, 'GET', null)
                }).then((resolved: any) => {
                    const res = resolved.employee;

                    this.departmentId = '';
                    this.departmentList = [];

                    _.forEach(res.data.departments, (department: any) => {
                        let chosenDepartment = _.findWhere(this.departmentBackupList, { id: department.departmentId });
                        if (chosenDepartment) {
                            this.departmentList.push(chosenDepartment);
                        }
                    });

                    if (this.departmentList.length > 0) {
                        this.departmentId = this.departmentList[0].id;
                    }

                    this.filterCriteria.criteria.departmentId = this.departmentId;
                    this.filterCriteria.criteria.employeeIds = [this.employee.id];

                    this.busyService.stop();
                    this.changeCategory();
                });
            } else {
                /*
                this.departmentList = angular.copy(this.departmentBackupList);
                this.departmentId = this.departmentList[0].id;
                this.filterCriteria.criteria.departmentId = this.departmentId;
                 */
                this.changeCategory();
                this.$q.when(this.departmentsLoaded).then(() => {
                    this.departmentList = angular.copy(this.departmentBackupList || []);
                });
            }
        }

        setItemTitle(item, row) {
            let differenceYear = this.filterCriteria.criteria.year == item.year,
                employee = _.findWhere(this.employeesList, {id: item.id}),
                department = _.findWhere(this.departmentList, {id: item.id});

            if (employee) {
                row.title = differenceYear ? employee['displayName'] : `${employee['displayName']} ${item.year}`;
            } else if (department) {
                row.title = differenceYear ? 'Department Overall' : `Department Overall ${item.year}`;
            }
        };

        public clearFilter(): void {
            this.filterCriteria.criteria.departmentId = '';
            this.departmentList = angular.copy(this.departmentBackupList);
            this.departmentId = '';
            this.filterCriteria.criteria.employeeIds = [];
            this.employeeCriteria.departmentId = '';
            if(!this.viewAllEmployeesHide) {
                this.employee = '';
            }
        }

        connectFloatingHeaders(): void {
            var container = $('#employee-goal.goals-scrolling-container');
            container.scroll(function () {
                $('.employee-goal-headers').css({ "left": (container.scrollLeft() * -1) });
                $('.goal-background-mover').css({ "left": (container.scrollLeft() * 1) });
                $('.goal-component-row-titles').css({ "left": (container.scrollLeft()) });
                $('.goal-plugin__group-label').css({ "left": (container.scrollLeft()) });
                $('.goal-plugin__pinned-summary-ground').css({ "left": (container.scrollLeft()) });
                container.find('.pager-button-container').css({ "left": (container.scrollLeft()) });
            })
        }
    }

    angular.module('meevo.plugins.employeeGoal')
        .controller('meevo.plugins.employeeGoal.EmployeeGoalController', EmployeeGoalController);
}
